import YFormContentSpecs from './ContentSpecs';

export { YFormContentSpecs };
export default YFormContentSpecs;
